import { createSlice } from '@reduxjs/toolkit';

const emptyTotals = {
    contractors: 0,
    balance: 0,
    bucket0to30: 0,
    bucket31to60: 0,
    bucket61to90: 0,
    bucket90Plus: 0,
    unaged: 0,
    inactiveContractors: 0,
    inactiveBalance: 0,
    stuckContractors: 0,
    avgAgeDays: null,
    oldestDollarAgeDays: null,
};

const initialState = {
    isLoading: false,
    error: null,
    rows: [],
    count: 0,
    totals: { ...emptyTotals },
    generatedAt: null,
    filters: {
        // Server-side: anything at or above this balance is included.
        minBalance: '0.01',
    },
};

const slice = createSlice({
    name: 'walletBalanceAgingReport',
    initialState,
    reducers: {
        fetchReport: state => {
            state.isLoading = true;
            state.error = null;
        },
        reportFetched: (state, { payload }) => {
            state.isLoading = false;
            state.rows = payload.rows || [];
            state.count = payload.count || 0;
            state.totals = payload.totals || { ...emptyTotals };
            state.generatedAt = payload.generatedAt || null;
        },
        reportFetchFailed: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload || 'Failed to load wallet balances report';
        },
        setFilters: (state, { payload }) => {
            state.filters = { ...state.filters, ...payload };
        },
    },
});

export const { fetchReport, reportFetched, reportFetchFailed, setFilters } =
    slice.actions;

export default slice.reducer;

export const selectWalletBalanceAgingReport = state =>
    state.walletBalanceAgingReport;
